import { ImgHTMLAttributes } from "react";

export const LogoBlackOnWhite = (props?: ImgHTMLAttributes<Element>) => {
  return <img src="/logoBlackOnWhite.svg" {...props} alt="Logo" />;
};
export default LogoBlackOnWhite;
